import { ApiClient, CryptoLocalStorage } from "zoox-infra";
const { stringifyUrl, stringify } = require("query-string");
import moment from "moment";

import CompanyService from "@/service/company-service";
import i18n from "@/middlewares/i18n";

export default class PaymentService {
  constructor() {
    this.apiClient = new ApiClient();
    this.companyService = new CompanyService();
  }

  requestPayment(
    orderId,
    customerName,
    code,
    phone,
    email,
    amount,
    description,
    message,
    itemCategory,
    metadata
  ) {
    return this.apiClient.post("payment/requestPayment", {
      orderId,
      customerName,
      code,
      phone,
      email,
      amount,
      description,
      message,
      itemCategory,
      metadata
    });
  }

  sendPaymentLinks(chargeId, customerName, phone, email, message, token) {
    return this.apiClient.post("payment/sendPaymentLinks", {
      chargeId,
      customerName,
      phone,
      email,
      message,
      token
    });
  }

  cancelPayment(chargeId, payload) {
    return this.apiClient.delete(
      `payment/charge/${chargeId}`,
      true,
      true,
      payload
    );
  }

  getMadeCharges(startDate, endDate, itemCategory) {
    var query = {};
    query.createdAt = [];

    if (startDate !== "") query.createdAt.push(`${startDate} 00:00:00`);
    if (endDate !== "") query.createdAt.push(`${endDate} 23:59:59`);
    if (itemCategory) query.metadataType = itemCategory;
    const requestURL = stringifyUrl({
      url: `payment/list`,
      query: query
    });
    return this.apiClient.get(requestURL);
  }

  getPayments(params) {
    const qs = this.handleParams(params);
    return this.apiClient.get(`payment/list?${qs}`);
  }

  exportPayments(params) {
    delete params.page;
    const qs = this.handleParams(params);
    return this.apiClient.downLoadFile(`payment/export?${qs}`);
  }

  getOrdersToChargeAtCheckin(params) {
    const qs = this.handleParams(params);
    return this.apiClient.get(`payment/order/charges-checkin?${qs}`);
  }

  exportOrdersToChargeAtCheckin(params) {
    delete params.page;
    const qs = this.handleParams(params);
    return this.apiClient.downLoadFile(
      `payment/order/charges-checkin/export?${qs}`
    );
  }

  createPayment(
    orderId,
    customerName,
    code,
    phone,
    email,
    amount,
    description,
    itemCategory,
    metadata
  ) {
    return this.apiClient.post("payment/createPayment", {
      orderId,
      customerName,
      code,
      phone,
      email,
      amount,
      description,
      itemCategory,
      metadata
    });
  }

  updatePayment(orderId, itemId, chargeId, itemData, chargeData) {
    return this.apiClient.put("payment/updatePayment", {
      orderId,
      itemId,
      chargeId,
      itemData,
      chargeData
    });
  }

  handleParams({
    companyId,
    code,
    orderCode,
    orderId,
    customerName,
    metadataType,
    metadataOrigin,
    createdAtStart,
    createdAtEnd,
    status,
    method,
    closed,
    clientsName,
    metadataCheckinDateStart,
    metadataCheckinDateEnd,
    metadataReservationStatus,
    page,
    sort,
    order,
    pageSize
  }) {
    let params = { _count: 1 };

    if (companyId) {
      params.companyId = companyId;
    }

    if (code) {
      params.code = code;
    }

    if (orderCode) {
      params.orderCode = orderCode;
    }

    if (orderId) {
      params.orderId = orderId;
    }

    if (createdAtStart) {
      createdAtStart = moment
        .utc(createdAtStart)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      params.createdAt = `>=${createdAtStart}`;
    }

    if (createdAtEnd) {
      createdAtEnd = moment
        .utc(createdAtEnd)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      params.createdAt = `<=${createdAtEnd}`;
    }

    if (createdAtStart && createdAtEnd) {
      createdAtStart = moment
        .utc(createdAtStart)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      createdAtEnd = moment
        .utc(createdAtEnd)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      params.createdAt = [`>=${createdAtStart}`, `<=${createdAtEnd}`];
    }

    if (customerName) {
      params.customerName = customerName;
    }

    if (metadataType) {
      params.metadataType = metadataType;
    }

    if (metadataOrigin) {
      params.metadataOrigin = metadataOrigin;
    }

    if (status) {
      params.status = status;
    }

    if (method) {
      params.method = method;
    }

    if (closed) {
      params.closed = closed;
    }

    if (clientsName) {
      params.clientsName = clientsName;
    }

    if (metadataCheckinDateStart) {
      metadataCheckinDateStart = moment
        .utc(metadataCheckinDateStart)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      params.metadataCheckinDate = `>=${metadataCheckinDateStart}`;
    }

    if (metadataCheckinDateEnd) {
      metadataCheckinDateEnd = moment
        .utc(metadataCheckinDateEnd)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      params.metadataCheckinDate = `<=${metadataCheckinDateEnd}`;
    }

    if (metadataCheckinDateStart && metadataCheckinDateEnd) {
      metadataCheckinDateStart = moment
        .utc(metadataCheckinDateStart)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      metadataCheckinDateEnd = moment
        .utc(metadataCheckinDateEnd)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      params.metadataCheckinDate = [
        `>=${metadataCheckinDateStart}`,
        `<=${metadataCheckinDateEnd}`
      ];
    }

    if (metadataReservationStatus !== undefined) {
      params.metadataReservationStatus = metadataReservationStatus;
    }

    if (page) {
      params.page = page;
    }

    if (sort) {
      params.sort = sort;
    } else {
      params.sort = "created";
    }

    if (order && order !== "") {
      params.order = order;
    } else {
      params.order = -1;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    } else {
      params.pageSize = 25;
    }

    return stringify(params, {
      encode: false,
      indices: false
    });
  }

  generatePin(personId, orderId, chargeId = null) {
    const company = this.companyService.getCurrentCompany();
    return this.apiClient.post("payment/generatePin", {
      orderId,
      chargeId,
      personId,
      message: `${company.name} : ${i18n.t(
        "PAYMENT_SOLICITATION.GENERATE_PIN"
      )}`
    });
  }

  async validatePin(personId, orderId, pin, chargeId = null) {
    const resp = await this.apiClient.post("payment/validatePin", {
      orderId,
      chargeId,
      personId,
      pin: parseInt(pin)
    });

    return resp.validated;
  }

  async getChargeByOrderIdAndChargeId(orderId, chargeId) {
    const resp = await this.apiClient.get(
      `payment/getChargeByOrderIdAndChargeId/${orderId}/${chargeId}`
    );
    return resp;
  }

  async getCharges(orderId, params) {
    const qs = stringify(params);
    const resp = await this.apiClient.get(
      `payment/order/${orderId}/charges?${qs}`
    );
    return resp._embedded.charges;
  }

  async updatePersonCharge(
    personId,
    chargeToken,
    personName,
    personPhone,
    personEmail
  ) {
    return this.apiClient.put("payment/person/charge", {
      personId,
      chargeToken,
      personName,
      personPhone,
      personEmail
    });
  }

  async payDirectly(orderId, chargeId, personId, payments, isClosed = false) {
    return this.apiClient.post("payment/pay", {
      orderId,
      chargeId,
      personId,
      isClosed,
      payments
    });
  }

  async pay(orderId, chargeId, personId, payments, isClosed = false) {
    return this.apiClient.post("payment/pay", {
      orderId,
      chargeId,
      personId,
      isClosed,
      payments
    });
  }

  setChargeToken(chargeToken = null) {
    CryptoLocalStorage.setItem("charge_token", chargeToken);
  }

  getChargeToken() {
    return CryptoLocalStorage.getItem("charge_token") || null;
  }

  setCurrentChargeToken(chargeToken = null) {
    CryptoLocalStorage.setItem("current_charge_token", chargeToken);
  }

  getCurrentChargeToken() {
    return CryptoLocalStorage.getItem("current_charge_token") || null;
  }

  async updateCustomer(data) {
    return this.apiClient.put("payment/customer", data);
  }

  async createCustomer(personId) {
    return this.apiClient.post("payment/customer", { personId });
  }
}
